import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { messageDeliveryStatus } from "../../../Helpers/Chat/RecentChat";
import { isGroupChat } from "../../../Helpers/Chat/ChatHelper";
import { IconUploading } from "../../../assets/images";
import { MSG_PROCESSING_STATUS_ID, GROUP_CHAT_PROFILE_UPDATED_NOTIFY, MSG_SEEN_STATUS_ID } from "../../../Helpers/Chat/Constant";
import { isLocalUser, formatGroupIdToJid } from "../../../Helpers/Chat/User";
import { useGetTypingStatus } from "../../../CustomHooks/chat";
import SDK from "../../SDK";
import PropTypes from "prop-types";

const Message = (props) => {
  const { typingData: { id: typingId, data = [] } = {} } = useSelector((store) => store);

  const { lastMessage, publisherId, deleteStatus, onClickHandler = null } = props;
  const { messageId, chatUserType, fromUserId, msgStatus, msgType, seenReceipt } = props;
  
  
  

  const { isTyping, displayName } = useGetTypingStatus({
    typingId,
    typingData: data,
    fromUserId,
    chatType: chatUserType
  });


  useEffect(() => {
    // Get group chat status for recent chat
    if (isGroupChat(chatUserType) && isLocalUser(publisherId) && msgType !== GROUP_CHAT_PROFILE_UPDATED_NOTIFY) {
      const groupJid = formatGroupIdToJid(fromUserId);
      SDK.getGroupMsgInfo(groupJid, messageId, true);
    }
  }, []);

  /**
   * handleMsgStatusIcon() method to handle the message status icon.
   * @param {string} status
   */
 const messageStatus = (lastmessageStatus, seenReceipt, publisherid) => {

  if (!isLocalUser(publisherid)) return null;

  let statusClass = messageDeliveryStatus[lastmessageStatus];

  if(chatUserType === 'chat'){
    // If seenReceipt is null / undefined / empty → keep default statusClass
    if (seenReceipt === null || seenReceipt === undefined || seenReceipt === "") {
      return (
        <i className={statusClass}>
          {lastmessageStatus === MSG_PROCESSING_STATUS_ID ? <IconUploading /> : ""}
        </i>
      );
    }

    // Explicit check for seenReceipt === 0
    if (seenReceipt === 0) {
      if (lastmessageStatus === MSG_SEEN_STATUS_ID) {
        statusClass = "user-status-receive";
      } else {
        statusClass = "user-status-sent";
      }
    }
  }else{
    statusClass = messageDeliveryStatus[lastmessageStatus];
  }

 

  return (
    <i className={statusClass}>
      {lastmessageStatus === MSG_PROCESSING_STATUS_ID ? <IconUploading /> : ""}
    </i>
  );
};


  const status =
    msgType === GROUP_CHAT_PROFILE_UPDATED_NOTIFY || deleteStatus === 1 ? null : messageStatus(msgStatus, seenReceipt, publisherId);
   
    const getLastMessageClass = (chatUserType, lastMessage) => {
      const isReactNode = React.isValidElement(lastMessage);
      switch (chatUserType) {
        case "groupchat":
          return isReactNode ? "last_msgs only_msg" : "last_msgs";
        case "chat":
          return isReactNode ? "last_msgs only_msg" : "last_msgs";
        default:
          return "last_msgs";
      }
    };


  return (
    <span
      className="recentText"
      role="button"
      tabIndex="0"
      onClick={onClickHandler}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClickHandler();
        }
      }}
    >
      {isTyping ? (
        <span className="txtTyping">{displayName}</span>
      ) : (
        <>
          {lastMessage && (
            <>
              {status} <span className={getLastMessageClass(chatUserType, lastMessage)}>{lastMessage}</span>
            </>
          )}
        </>
      )}
    </span>
  );
};

export default Message;

Message.propTypes = {
  lastMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  publisherId: PropTypes.string,
  deleteStatus: PropTypes.number,
  onClickHandler: PropTypes.func,
  msgStatus: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  msgType: PropTypes.string,
  chatUserType: PropTypes.string,
  messageId: PropTypes.string,
  fromUserId: PropTypes.string
};
